import { Workstation } from 'app/containers/OrderDetails/types';

// Global switch stored in Kewapp (admin), see specs/plans/picking-order-by-address.md.
export type PickingOrderStrategy = 'legacy' | 'location';

export const DEFAULT_PICKING_ORDER_STRATEGY: PickingOrderStrategy = 'legacy';

export const shouldOrderByLocation = (
  strategy: PickingOrderStrategy,
  workstation?: Workstation,
): boolean =>
  strategy === 'location' &&
  (workstation === Workstation.Cabinet ||
    workstation === Workstation.Accessory ||
    workstation === Workstation.Drawer);
